export default __webpack_public_path__ + "static/media/011-scientist.c1e98d1c.svg";